export type Es5LintError = {
  message: string;
  line?: number | null;
  column?: number | null;
};

type GraphQlErrorLike = {
  message?: string;
  extensions?: {
    code?: string;
    line?: number | null;
    column?: number | null;
  };
};

/** Parse ES5 Uglifier validation errors from GraphQL mutation failures. */
export const extractEs5LintError = (error: unknown): Es5LintError | null => {
  const gqlError = error as GraphQlErrorLike | null | undefined;
  if (!gqlError || typeof gqlError !== "object") return null;
  if (gqlError.extensions?.code !== "ES5_VALIDATION_ERROR") return null;

  return {
    message: gqlError.message || "JavaScript の構文エラーです（ES5 のみ対応）",
    line: gqlError.extensions.line,
    column: gqlError.extensions.column,
  };
};

export const formatEs5LintError = (error: Es5LintError): string => {
  if (error.line != null) {
    const loc =
      error.column != null
        ? `行${error.line}, 列${error.column}`
        : `行${error.line}`;
    // Server message already includes 行N; avoid duplicating when present.
    if (error.message.startsWith("行")) return error.message;
    return `${loc}: ${error.message}`;
  }
  return error.message;
};
